import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const painPoints = ["The cut didn't turn out the way you asked", "The stylist didn't understand your vision", 'You paid too much for a mediocre result', 'You went home and had to fix it yourself'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function PainSection() {
  return <section className="py-24 px-4 bg-dark" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="font-display text-3xl md:text-4xl text-gold text-center mb-16 italic" data-id="element-96">
          We know exactly how you feel when...
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-6" data-id="element-97">
          {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="flex items-center gap-4 bg-matte p-6 rounded-lg border border-white/5" data-id="element-98">
              <XCircleIcon className="w-6 h-6 text-red-400/80 flex-shrink-0" data-id="element-99" />
              <p className="font-body text-cream text-lg md:text-xl font-light" data-id="element-100">
                {point}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}